export default __webpack_public_path__ + "static/media/back.d2023a89.svg";